export default __webpack_public_path__ + "693677f7fde1a9d1523154e699686ccc.svg";